import React, { FC } from "react";
import { Table } from "antd";
import PriceFormatter from "apps/Common/PriceFormatter";
import dayjs from "dayjs";
import { useGetAdvertPriceHistories } from "../../Ads/ServerSideStates";

const ListItems: FC<{ advertId?: string }> = ({ advertId }) => {
  const histories = useGetAdvertPriceHistories(advertId || "");
  const columns = [
    {
      title: "Fiyat",
      dataIndex: "price",
      key: "price",
      render: (price: number) => {
        return (
          <>
            <PriceFormatter inputPrice={price} />
          </>
        );
      },
    },
    {
      title: "Tarih",
      dataIndex: "date",
      key: "date",
      render: (date: string) => {
        return <>{dayjs(date).format("DD.MM.YYYY")}</>;
      },
    },
  ];

  return (
    <Table
      loading={histories.isLoading || histories.isFetching}
      columns={columns}
      dataSource={histories?.data?.data || []}
    />
    
  );
};

export default ListItems;
